// extracted by mini-css-extract-plugin
module.exports = {"container":"SmoothSlider-module--container--2XcRm","cards":"SmoothSlider-module--cards--2T7Az","shadowCurtain":"SmoothSlider-module--shadow-curtain--2Oca4"};